import { render, staticRenderFns } from "./PurchaseRequestForm.vue?vue&type=template&id=3ec49637&scoped=true"
import script from "./PurchaseRequestForm.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestForm.vue?vue&type=style&index=0&id=3ec49637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec49637",
  null
  
)

export default component.exports